import { Input, Label } from '@chain-zen/ui'
import { useState } from 'react'

interface RefNumberInputProps {
  onSubmit: (referenceNumber: string) => void
  referenceNumber: string
}

/**
 * Input component for editing reference number inline
 */
export const RefNumberInput = ({ referenceNumber, onSubmit }: RefNumberInputProps) => {
  const [value, setValue] = useState(referenceNumber)

  const handleBlur = () => {
    if (value !== referenceNumber) {
      onSubmit(value)
    }
  }

  return (
    <div className="space-y-1">
      <Label className="text-xs font-medium">Reference Number</Label>
      <Input
        value={value}
        placeholder="Enter reference number"
        onChange={(e) => setValue(e.target.value)}
        onBlur={handleBlur}
        className="h-7 text-xs"
      />
    </div>
  )
}
